var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9363 13.0728C21.1354 12.973 21.3027 12.8198 21.4197 12.6304C21.5367 12.4409 21.5986 12.2226 21.5986 12C21.5986 11.7773 21.5367 11.559 21.4197 11.3696C21.3027 11.1801 21.1354 11.0269 20.9363 10.9272L4.13631 2.52717C3.92801 2.42294 3.69387 2.38159 3.46247 2.40816C3.23106 2.43473 3.01239 2.52807 2.83313 2.6768C2.65387 2.82553 2.52176 3.02321 2.45294 3.24574C2.38411 3.46826 2.38153 3.70601 2.44551 3.92997L4.16031 9.92997C4.23204 10.1807 4.38352 10.4013 4.59182 10.5583C4.80011 10.7153 5.05389 10.8001 5.31471 10.8L10.7999 10.8C11.1182 10.8 11.4234 10.9264 11.6484 11.1514C11.8735 11.3765 11.9999 11.6817 11.9999 12C11.9999 12.3182 11.8735 12.6235 11.6484 12.8485C11.4234 13.0735 11.1182 13.2 10.7999 13.2L5.31471 13.2C5.05389 13.1998 4.80011 13.2847 4.59182 13.4416C4.38352 13.5986 4.23204 13.8192 4.16031 14.07L2.44671 20.07C2.3826 20.2939 2.38502 20.5316 2.45369 20.7541C2.52236 20.9767 2.65429 21.1744 2.83342 21.3233C3.01254 21.4721 3.2311 21.5656 3.46245 21.5924C3.6938 21.6191 3.92794 21.578 4.13631 21.474L20.9363 13.074L20.9363 13.0728Z",
    fill: "#0483F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.fa5ec875f55142d04e8e021477fdd42e.svg";
export { ForwardRef as ReactComponent };